import Template from './ExperienceSelectorView.njk';
import _ from "underscore";
import Marionette from "backbone.marionette";
import { ExperienceSelectorCollectionView } from "./ExperienceSelectorCollectionView";
import "./ExperienceSelectorView.less";

export const ExperienceSelectorView = Marionette.View.extend({
  template: Template,
    className: "ExperienceSelectorView",

    regions: {
        experiences: ".region-experiences"
    },
    events: {
        "change :checkbox": "onSelectAllToggle",
        "keyup #search-experience": "onSearch",
    },
    selectedExperiences: [],

    initialize(options) {
        this.selectedExperiences = _.clone(options.selectedExperiences);
        if (this.selectedExperiences.all) {
            this.selectedExperiences.selected = this.collection.pluck("id");
        }
    },

    _onSearch: _.debounce(function(value) {
        if (value.length) {
            this.getChildView("experiences").setFilter(function (experience) {
                return experience.get("name").match(new RegExp(value, "i"));
            });
        }
        else {
            this.getChildView("experiences").removeFilter();
        }
    }, 200),

    onSearch(event) {
        this._onSearch(event.target.value);
    },

    onSelectAllToggle(event) {
        if (event.target.checked) {
            this.selectedExperiences.all = true;
            this.selectedExperiences.selected = this.collection.pluck("id");
        }
        else {
            this.selectedExperiences.all = false;
            this.selectedExperiences.selected = [];
        }
        this.renderExperienceCount();
        this.getChildView("experiences").render();
        this.trigger("experienceSelectionChanged", _.clone(this.selectedExperiences));
    },

    onChildviewExperienceToggle(experienceItemView, event) {
        if (event.target.checked) {
            this.selectedExperiences.selected = _.union(this.selectedExperiences.selected, [event.target.value]);

            if (this.selectedExperiences.selected.length === this.collection.length) {
                this.selectedExperiences.all = true;
            }
        }
        else {
            this.selectedExperiences.all = false;
            this.selectedExperiences.selected = _.difference(this.selectedExperiences.selected, [event.target.value]);
        }

        this.renderExperienceCount();
        this.trigger("experienceSelectionChanged", _.clone(this.selectedExperiences));
    },

    renderExperienceCount() {
        if (this.selectedExperiences.all) {
            this.$el.find(".panel-heading .listing-count").html("All");
            this.$el.find(".panel-heading .select-all").prop("checked", true);
            this.$el.find(".panel-heading .select-all").prop("indeterminate", false);
        }
        else {
            if (this.selectedExperiences.selected.length === 0) {
                this.$el.find(".panel-heading .select-all").prop("checked", false);
                this.$el.find(".panel-heading .select-all").prop("indeterminate", false);
                this.$el.find(".panel-heading .listing-count").html("0");
            }
            else {
                this.$el.find(".panel-heading .select-all").prop("checked", true);
                this.$el.find(".panel-heading .select-all").prop("indeterminate", true);
                this.$el.find(".panel-heading .listing-count").html(this.selectedExperiences.selected.length);
            }
        }
    },

    onRender() {
        this.renderExperienceCount();

        var experiences = new ExperienceSelectorCollectionView({
            collection: this.collection,
            selectedExperiences: this.selectedExperiences
        });
        this.showChildView("experiences", experiences);
    }
});


// WEBPACK FOOTER //
// ./src/js/view/components/ExperienceSelector/ExperienceSelectorView.js